/**
 * Un turbo-frame hébergé par un side panel ou une modale (dialog) fermés s'ouvre avec son hôte
 * dès qu'un contenu y arrive — un formulaire qui le cible (`data-turbo-frame`), un redirect
 * que Turbo suit dans le frame. L'ouverture se fait AVANT le rendu (crochet
 * `turbo:before-frame-render`, comme lib/frame_transitions) : l'hôte glisse sur son squelette
 * et le contenu se rend dedans, animé si le frame porte `data-view-transition`.
 *
 * Opt-in : seuls les frames marqués `data-opens-host` (document_editor : le side panel de
 * l'éditeur, SidePanelHelper#editor_side_panel ; LEGACY_EDITOR, la modale, #editor_modal).
 * L'hôte déjà ouvert ne bouge pas (l'étape du format puis l'éditeur, dans le même frame).
 *
 * C'est ce qui permet aux entrées de l'îlot du publisher d'être des formulaires ordinaires
 * (POST du brouillon, 303 vers son éditeur) plutôt que des fetch suivis d'une navigation.
 */
document.addEventListener("turbo:before-frame-render", (event) => {
  const frame = event.target;
  if (!frame.hasAttribute("data-opens-host")) return;

  // LEGACY_EDITOR : le frame peut vivre dans un dialog (application/_dialog) plutôt qu'un panel
  const host = frame.closest("[data-controller~='side-panel'], [data-controller~='dialog']");
  if (!host || host.querySelector("dialog")?.open) return;

  if (host.matches("[data-controller~='dialog']")) window.openDialog?.(host.id);
  else window.openSidePanel?.(host.id);
});
